<template>
  <div class="container">
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Warsztaty
    </div>
    <div class="offer-container" v-if="!sequencingWorkshopsExpired">
      <!-- <path-navigation
        v-if="workshop && (!workshop.type || workshop.type === 'STANDARD')"
        :paths="[
          {
            name: 'Warsztaty z sekwencjonowania',
            to: `/warsztaty-z-sekwencjonowania/${this.$route.params.id}`,
          },
        ]"
      />
      <path-navigation
        v-if="workshop && workshop.type === 'PRICE_TARIFF'"
        :paths="[
          {
            name: 'Warsztaty z taryfami',
            to: `/warsztaty-z-taryfami/${this.$route.params.id}`,
          },
        ]"
      /> -->

      <section>
        <h2 class="sub-title">{{ workshop ? `${workshop.name}` : "" }}</h2>

        <div
          class="workshops"
          v-if="workshop && workshop.items && workshop.items.length > 0"
        >
          <div
            class="profile-card"
            v-for="type in Object.keys(workshopItemsByType)"
            :key="type"
          >
            <p class="type-label sub-title">{{ translateType(type) }}</p>
            <div v-for="item in workshopItemsByType[type]" :key="item.id">
              <div class="workshop">
                <img class="mb-4" :src="getImage(item)" />
                <div class="workshop-description">
                  <p class="sub-title">{{ item.name }}</p>
                  <p style="font-size: 13px;">{{ item.description }}</p>
                </div>
              </div>
              <div class="" style="margin: auto;">
                <rounded-color-button
                :label="'Oglądaj'"
                :width="'200px'"
                style="margin: auto; margin-top: 30px; margin-bottom: 50px;"
                :classes="'withLetterSpacing'"
                @clicked="moveToVideo(item)"
              />
              </div>
           
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class="ml-1">Brak nagrań do wyświetlenia</h3>
        </div>
      </section>
    </div>

    <div
      class="workshops-expired pt-4 text-center"
      v-if="sequencingWorkshopsExpired"
    >
      <p>
        Czas dostępu do warsztatów minął. Aby kontynuować praktykę, przedłuż
        swój dostęp, kupując warsztaty ponownie.
      </p>

      <rounded-color-button
        :label="'Wykup dostęp'"
        :width="'100%'"
        :classes="'withLetterSpacing'"
        @clicked="moveToBuyWorkshop"
      />
    </div>
  </div>
</template>

<script>
import { SERVER_URL } from "../axios";
import RoundedColorButton from "../components/buttons/RoundedColorButton.vue";

export default {
  metaInfo: {
    title: "Dagajoga warsztaty - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "SequencingWorkshops",
  data: () => ({
    sequencingWorkshopsExpired: false,
  }),
  components: {
    RoundedColorButton,
  },
  props: {
    path: String,
  },

  async mounted() {
    await this.$store.dispatch(
      "sequencingWorkshops/fetchSequencingWorkshop",
      this.$route.params.id
    );
    const isPaid = await this.$store.dispatch(
      "sequencingWorkshops/checkUserPaidForWorkshop",
      this.$route.params.id
    );
    if (!isPaid) {
      this.redirectLogin();
    } else {
      const isNotExpired = await this.$store.dispatch(
        "sequencingWorkshops/checkTariffWorkshopIsNotExpired",
        this.$route.params.id
      );

      if (!isNotExpired) {
        this.sequencingWorkshopsExpired = true;
      }
    }
  },

  computed: {
    types() {
      return [
        {
          id: "TRAINING",
          name: "Praktyki",
        },
        {
          id: "WORKSHOP_RECORDING",
          name: "Nagrania z warsztatów",
        },

        {
          id: "TRAINING_RECORDING",
          name: "Nagrania z praktyki",
        },
      ];
    },
    workshop() {
      return this.$store.getters["sequencingWorkshops/getSequencingWorkshop"];
    },
    workshopItemsByType() {
      let itemsByType = {};
      this.workshop.items.forEach((item) => {
        const type = item.type;
        const alreadyAddedType = itemsByType[type];
        if (alreadyAddedType) {
          alreadyAddedType.push(item);
        } else {
          itemsByType[type] = [item];
        }
      });

      return itemsByType;
    },
  },
  methods: {
    moveToBuyWorkshop() {
      this.$router.push({
        name: "SequencingWorkshopPayment",
        id: this.$route.params.id,
      });
    },
    translateType(type) {
      if (type === "STANDARD") {
        return "";
      }
      const foundType = this.types.find((t) => t.id === type);
      if (foundType) {
        return foundType.name;
      } else {
        return type;
      }
    },

    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: { name: "", signup: signup },
      });
    },
    async moveToVideo(item) {
      await this.$store.dispatch(
        "sequencingWorkshops/setSequencingWorkshopItemToNull"
      );
      await this.$store.dispatch(
        "sequencingWorkshops/fetchSequencingWorkshopItem",
        item.id
      );
      this.$router.push({
        name: "SequencingWorkshopVideo",
        params: {
          id: item.id,
          path: `warsztaty-z-sekwencjonowania/${this.$route.params.id}`,
        },
      });
    },
    getImage(item) {
      const extension = item.imagePath?.split(".")[1];
      return `${SERVER_URL}sequencingWorkshopItem_${
        item.id
      }.${extension}?d=${new Date().getTime()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  margin: 0;
}
.type-content {
  padding: 1rem;
  border-radius: 20px;
  margin-bottom: 3rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.type-label {
  font-size: 30px;
  font-weight: 500;
  color: #54514C !important;
}

.offer-container {
  @media (max-width: 1024px) {
    padding-left: 3.5%;
  }
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  h2 {
    font-size: 2.4rem;
    padding-bottom: 1.5rem;
    @media (max-width: 768px) {
      font-size: 2.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1.7rem;
      text-align: center;
      padding-bottom: 1rem;
    }
  }
  p {
    color: #000;
  }
  .path {
    a {
      color: #000;
      text-decoration: none;
      font-weight: 500;
    }
    @media (max-width: 425px) {
      margin-top: -2rem;
      padding-bottom: 20px !important;
    }
  }

  .offer-description {
    p {
      font-size: 1.05rem;
      width: 85%;
      margin-bottom: 3rem;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }

  .box-container {
    display: flex;
    justify-content: center;
    margin-right: 7%;
    margin-bottom: 5rem;

    @media (max-width: 1024px) {
      margin-right: 0%;
    }

    @media (max-width: 425px) {
      flex-wrap: wrap;
    }
    .box {
      @media (max-width: 425px) {
        margin-bottom: 3rem;
      }
    }
  }
}
.profile-card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: 30px auto;
  max-width: 90vw;
}

.workshops {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.workshop {
  display: flex;
  align-content: center;
  flex-direction: column;
  margin-top: 4rem;
  flex-wrap: wrap;
}
.workshop-description {
  display: flex;
  flex-direction: column;
  color: #54514c;
  @media (max-width: 425px) {
    text-align: center;
    margin-left: 0;
  }
}
.workshop-description p {
  color: #54514C;
}
.workshop img {
  width: 200px;
  height: 200px;
  border-radius: 20px;
  box-shadow: 0px 0px 100px 25px #b6afa5;

  object-fit: cover;
  margin: auto;
}
</style>
